enum Paths {
  BASE = '',
  LOGIN = BASE + '/login',
  AUTH_CALLBACK = BASE + '/auth/callback',
  MAIN = BASE + '/main',
  MESSAGES_PATH = BASE + '/main/messages',
  MESSAGES = BASE + '/main/messages/:type?',
  MESSAGES_CHATS = BASE + '/main/messages/chats',
  MESSAGES_UNREAD = BASE + '/main/messages/unread',
  CALLS = BASE + '/main/calls',
  FEEDS = BASE + '/main/feeds',
  SHORTS = BASE + '/main/shorts',
  User = BASE + '/main/user',
  Wallet = BASE + '/main/wallet',
  CONTACTS = BASE + '/main/contacts',
  SETTINGS_PATH = BASE + '/main/settings',
  SETTINGS = BASE + '/main/settings/:type?',
  SETTINGS_NOTIFICATIONS = BASE + '/main/settings/notifications',
  SETTINGS_SECURITY = BASE + '/main/settings/security',
  SETTINGS_PRIVACY = BASE + '/main/settings/privacy',
  SETTINGS_ABOUT = BASE + '/main/settings/about',
}

export default Paths;
